/**
 * Performance Optimization Hook
 * Pre-warms browser systems for better avatar performance
 */

import { useEffect } from "react";

export const usePerformanceOptimizations = () => {
  useEffect(() => {
    // Pre-warm audio context
    const warmUpAudio = async () => {
      try {
        // Create and start audio context to reduce first-play latency
        const AudioContext =
          window.AudioContext || (window as any).webkitAudioContext;
        if (AudioContext) {
          const audioContext = new AudioContext();

          // Resume if suspended (browser autoplay policy)
          if (audioContext.state === "suspended") {
            await audioContext.resume();
          }
        }
      } catch (error) {}
    };

    // Pre-load critical resources
    const preloadResources = () => {
      // Pre-connect to Azure services
      const preconnectDomains = [
        "https://westeurope.tts.speech.microsoft.com",
        "https://custom-avatar-wisam.services.ai.azure.com",
      ];

      preconnectDomains.forEach((domain) => {
        const link = document.createElement("link");
        link.rel = "preconnect";
        link.href = domain;
        link.crossOrigin = "anonymous";
        document.head.appendChild(link);
      });
    };

    // Request idle callback for non-critical optimizations
    if ("requestIdleCallback" in window) {
      requestIdleCallback(() => {
        warmUpAudio();
        preloadResources();
      });
    } else {
      // Fallback for browsers without requestIdleCallback
      setTimeout(() => {
        warmUpAudio();
        preloadResources();
      }, 100);
    }

    // Cleanup
    return () => {
      // Nothing to cleanup
    };
  }, []);
};
